import { ReactNode } from 'react';
import { View } from 'react-native';
import { Text } from '@/components/Text';
import { styles } from './Section.styles';

type SectionProps = {
  title: string;
  content?: string;
  children?: ReactNode;
  bodyNode?: ReactNode;
};

export const Section = ({
  title,
  content,
  children,
  bodyNode,
}: SectionProps) => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>{title}</Text>
      <View style={styles.contentWrapper}>
        {content || children ? (
          <Text style={styles.contentText}>
            {content} {children}
          </Text>
        ) : null}
        {bodyNode}
      </View>
    </View>
  );
};
